import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientStep, AdminRecipientStepPayload } from '../types'

/** Updates a recipient step (`PUT …/versions/{versionRef}/recipient-steps/{recipientStepRef}`). */
export const useUpdateAdminRecipientStep = (
  formReferenceID: string,
  versionReferenceID: string,
  recipientStepReferenceID: string,
) =>
  useAdminUpdate<AdminRecipientStepPayload, AdminRecipientStep>({
    path: `/api/forms/${formReferenceID}/versions/${versionReferenceID}/recipient-steps/${recipientStepReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the recipient step',
    successMessage: 'Recipient step updated',
  })
